import { render } from "./ColumnsSettings.vue?vue&type=template&id=6717ab08&ts=true"
import script from "./ColumnsSettings.vue?vue&type=script&lang=ts"
export * from "./ColumnsSettings.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__